import { useState } from 'react';
import { useTheme } from '@flowcore-water/ui';

interface RawJsonViewerProps {
  data: unknown;
  label?: string;
}

export function RawJsonViewer({ data, label = 'Raw JSON' }: RawJsonViewerProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTheme();

  const formatted = typeof data === 'string'
    ? (() => { try { return JSON.stringify(JSON.parse(data), null, 2); } catch { return data; } })()
    : JSON.stringify(data, null, 2);

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-xs font-medium"
        style={{ color: t.accent }}
      >
        <span>{open ? '▾' : '▸'}</span>
        {label}
      </button>
      {open && (
        <pre
          className="mt-2 max-h-96 overflow-auto rounded-lg border p-3 text-xs"
          style={{
            background: t.expandedRowBg,
            borderColor: t.borderSubtle,
            color: t.textSecondary,
          }}
        >
          {formatted}
        </pre>
      )}
    </div>
  );
}
